import React, { createContext, useContext, useState } from "react";

type NameDropContextType = {
    isNameDropSeen: boolean;
    setNameDropSeen: () => void;
};

const NameDropContext = createContext<NameDropContextType | undefined>(undefined);

export const NameDropProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isNameDropSeen, setIsNameDropSeen] = useState(() => {
        return localStorage.getItem("nameDropSeen") === "true";
    });

    const setNameDropSeen = () => {
        localStorage.setItem("nameDropSeen", "true");
        setIsNameDropSeen(true);
    };

    return (
        <NameDropContext.Provider value={{ isNameDropSeen, setNameDropSeen }}>
            {children}
        </NameDropContext.Provider>
    );
};

export const useNameDrop = () => {
    const context = useContext(NameDropContext);
    if (!context) {
        throw new Error("useNameDrop must be used within a NameDropProvider");
    }
    return context;
};